import { FACET_TEXT } from "@/v2-backoffice-client/translation/publish/translation.publish.utils"

// One pending-changelog line, flattened for the table. Mirrors the
// CatalogChange union: text rows carry a name/description pair per language,
// every other facet carries a single before/after value.
export type PendingChangeRow = {
  key: string
  facet: string
  objectType: string
  code: string
  languageCode: string
  kind: string // added | modified | removed
  oldName: string
  oldDescription: string
  newName: string
  newDescription: string
  // Non-text facets: the single value that moved.
  oldValue: string
  newValue: string
  // Null marks an addition for the revert payload (revert = delete row).
  revertName: string | null
  revertDescription: string | null
  user: string
  updatedAt: string
}

// Only text is authored in the catalog alone, so only text can be reverted
// from here: the other facets were written to the runtime first, and undoing
// one means re-saving it on the feature itself.
export function isRevertable(row: PendingChangeRow) {
  return row.facet === FACET_TEXT
}
